import script from "./Podcast.vue?vue&type=script&setup=true&lang=js"
export * from "./Podcast.vue?vue&type=script&setup=true&lang=js"

import "./Podcast.vue?vue&type=style&index=0&id=4432fc45&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4432fc45"]])

export default __exports__